export default __webpack_public_path__ + "static/media/r-lemon-tree@3x.af25bfb4.png";